import React, { useState, useEffect, useRef } from 'react'
import { colorPalette } from './data';
import { useDispatch, useSelector } from "react-redux";
import { fetchLeanStartupCanvasApi, resetbibErr } from './leanstartupcanvasSlice'
import StickyNoteCompo from './StickyNoteCompo';
import Download from "./asset/Download.svg"
import { Button } from "antd";
import DescribeFeature from '../reuseablecomponent/DescribeFeature';
import { updateSlideNumber } from './leanstartupcanvasSlice';
import { useNavigate } from "react-router-dom"
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from "moment";
import MessageNotification from '../reuseablecomponent/MessageNotification';
import { fileNameSuffix } from '../../utils/fileNameSuffix';
import { postUserActivityDataApi } from '../UserActivity/userActivitySlice';
import lsc_locals from "../../localization/localization_en_lean_startup_canvas.json";
import notification_locas from "../../localization/localization.en_notification_message.json"
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import WarningFreeTrialAccessResource from '../reuseablecomponent/PopUpVarients/WarningFreeTrialAccessResource';
import WarningLimitedResourceOopsPopup from '../reuseablecomponent/PopUpVarients/WarningLimitedResourceOopsPopup';
import { paywall_locals } from '../../localization';
import BlurContainer from '../../DesignSystem/Container/BlurContainer';
import useApp from '../../hooks/useApp';
import BrainStromModeTemplate from '../buildbusinesscanvas/BrainStromModeTemplate';
import PrimaryButton from '../../DesignSystem/Buttons/PrimaryButton';

const PAYWALL_LOCALS = paywall_locals.lean_startup_canvas;

const locals = lsc_locals.lean_startup_canvas;

const LSCStickyNotes = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isShowBrainStromMode, setIsShowBrainStromMode] = useState(true);
    const permission = useSelector((state) => state.user.permission);
    const pdfRef = useRef();
    const [data, setData] = useState([]);
    const Metrics = useSelector((state) => state.leanstartupcanvas.Metrics);
    const status = useSelector((state) => state.leanstartupcanvas.status);
    const error = useSelector((state) => state.leanstartupcanvas.error);
    const [showEditIcon, setShowEditIcon] = useState(true);
    const { upgradeRenewPaywallPopup, isFreeSubscription } = useApp();
    useEffect(() => {
        dispatch(fetchLeanStartupCanvasApi());
    }, [])
    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(resetbibErr());
        }, 3000)
        return () => clearTimeout(timer);
    }, [error])
    useEffect(() => {
        const keys = Object.keys(Metrics); // Get all the keys of the object
        const slicedObjects = [];

        for (let i = 0; i < keys.length; i += 3) {
            const sliceKeys = keys.slice(i, i + 3);
            const slicedObject = {};

            for (const key of sliceKeys) {
                slicedObject[key] = Metrics[key];
            }

            slicedObjects.push(slicedObject);
        }
        setData(slicedObjects);
    }, [Metrics])

    if (status == "failed") {
        return <p>{error}</p>
    }

    const downloadPDF = () => {
        setShowEditIcon((prev) => !prev);
        setTimeout(() => {
            const input = pdfRef.current;
            html2canvas(input).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = canvas.width;
                const imgHeight = canvas.height;
                const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
                const imgX = (pdfWidth - imgWidth * ratio) / 2;
                const imgY = 0;
                pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
                const currentDate = moment();
                const fileName = fileNameSuffix();
                pdf.save(`LeanStartupCanvas_${fileName}.pdf`);
                setShowEditIcon((prev) => !prev);
            });
        }, 1000);
        dispatch(postUserActivityDataApi({ ...notification_locas.notification_message.lean_startup_canvas.download }))
    };
    const structuredData = {
        "Customer Segments": [],
        "Problem": [],
        "Revenue Streams": [],
        "Solution": [],
        "Value Propositions": [],
        "Channels": [],
        "Key Metrics": [],
        "Cost Structure": [],
        "Unfair Advantage": []
    }
    return (
        <div className='pt-[6.5rem] w-[95%] mx-auto'>
            <DescribeFeature text={locals.module_title} description={locals.module_description} />
            <div className="w-full flex justify-end mb-[1rem]">
                <WarningLimitedResourceOopsPopup
                    module_data={{ "module": "bbc_lsc", "data": data }}
                    description1={PAYWALL_LOCALS[upgradeRenewPaywallPopup].download.description1}
                    description2={PAYWALL_LOCALS[upgradeRenewPaywallPopup].download.description2}
                >
                    {({ handleTogglePopup, isFreeSubscription, accessDownload }) => (
                        <button disabled={!permission.download} className='cursor-pointer' style={{ margin: '0' }} onClick={() => (isFreeSubscription || accessDownload) ? handleTogglePopup() : downloadPDF()}><DownloadOutlinedIcon fontSize='medium' /></button>
                    )}
                </WarningLimitedResourceOopsPopup>
            </div>
            <BlurContainer
                isShowBlurEffect={isFreeSubscription}
            >
                {
                    !isShowBrainStromMode
                        ? (
                            <section ref={pdfRef}>
                                {
                                    data?.map((item, i) => {
                                        const subItem = Object.entries(item);
                                        return <StickyNoteCompo showEditIcon={showEditIcon} SlideNumber={i} bgColor={colorPalette[i]} data={subItem} />
                                    })
                                }
                            </section>
                        ) : (
                            <section ref={pdfRef}>
                                <BrainStromModeTemplate
                                    data={data}
                                    structuredData={structuredData}
                                />
                            </section>
                        )
                }
            </BlurContainer>
            <div className="w-full flex justify-between my-[48px]">
                <Button onClick={() => {
                    dispatch(updateSlideNumber({ type: "independent", SlideNumber: 2 }));
                    navigate('/product/home/businesscanvas/leanstartupcanvas')
                }} className="border-primary text-primary px-[32px] py-[12px] text-[16px] font-InterRegular font-medium tracking-wide h-auto rounded-[8px]">{locals.button_controls[1]}</Button>
                <PrimaryButton onClick={() => setIsShowBrainStromMode((prev) => !prev)} text={isShowBrainStromMode ? "Switch to Brainstorm Mode" : "Switch to Canvas Mode"} />
                <Button onClick={() => {
                    navigate('/product/home');
                }} className=" bg-primary text-[#EBF1FF] px-[32px] py-[12px] text-[16px] font-InterRegular font-medium tracking-wide h-auto rounded-[8px]">{locals.button_controls[3]}</Button>
            </div>
        </div>
    )
}

export default LSCStickyNotes